export default "__VITE_ASSET__DUbJ_5uJ__"